import * as React from 'react';

import classnames from 'classnames';
import styles from './accent-border.module.css';

type Props = {
    children: React.ReactNode;
    color: string;
    location?: 'top' | 'left' | 'bottom' | 'right';
};

AccentBorder.defaultProps = {
    location: 'left',
};

/**
 * Renders a border along an edge of a container, typically used inside a `<Card>` component.
 */
export function AccentBorder({color, location, children}: Props) {
    const accentBorderStyle = {borderColor: color} as const;

    const styleName = classnames(styles['accent-border'], {
        [styles['top']]: location === 'top',
        [styles['left']]: location === 'left',
        [styles['bottom']]: location === 'bottom',
        [styles['right']]: location === 'right',
    });

    return (
        <div style={accentBorderStyle} className={styleName}>
            {children}
        </div>
    );
}
